// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectReportDeliveryMethodQueryResult, selectReportDeliveryMethodsPageLoading, selectReportDeliveryMethodsShowInitWaitingMessage} from '../_selectors/report-delivery-method.selectors';

export class ReportDeliveryMethodsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectReportDeliveryMethodsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectReportDeliveryMethodsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectReportDeliveryMethodQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
